"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueMutations = queueMutations;
exports.deQueueMutations = deQueueMutations;
exports.discardMutationsQueue = discardMutationsQueue;
exports.mergeUserEntities = mergeUserEntities;
exports.mergeUserEntitiesAndDeuqueQueuedMutations = mergeUserEntitiesAndDeuqueQueuedMutations;
exports.applyCachePathes = applyCachePathes;
function queueMutations(queueId, payload) {
    return {
        type: "query-user/queue-mutations",
        queueId,
        payload
    };
}
function deQueueMutations(queueId, payload) {
    return {
        type: "query-user/de-queue-mutations",
        queueId,
        payload
    };
}
function discardMutationsQueue(queueId) {
    return {
        type: "query-user/discard-mutations-queue",
        queueId
    };
}
function mergeUserEntities(entities, cachePatches) {
    return {
        type: "query-user/MergeUserEntities",
        payload: {
            entities,
            cachePatches
        }
    };
}
function mergeUserEntitiesAndDeuqueQueuedMutations(entities, cachePatches, queueId, mutationsToDequeue) {
    return {
        type: "query-user/MergeUserEntitiesAndDeuqueQueuedMutations",
        payload: {
            entities,
            cachePatches,
            queueId,
            mutationsToDequeue
        }
    };
}
function applyCachePathes(cachePatches) {
    return {
        type: "query-user/ApplyCachePathes",
        payload: cachePatches
    };
}
//# sourceMappingURL=actions-user.js.map